import { TRANSFER_SESSION, TRANSFER_SESSION_SUCCESS, TRANSFER_SESSION_ERROR, TRANSFER_SESSION_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const TransferSession = (state = initialState, action) => {
  switch (action.type) {
    case TRANSFER_SESSION:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case TRANSFER_SESSION_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case TRANSFER_SESSION_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case TRANSFER_SESSION_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default TransferSession;
